import React from 'react'
import WorkerSignUp from '../../Components/Worker/WorkerSignUp'
import Header from '../../Components/LoginFloder/Header'
// import Header 
const WorkerSignUpPage = () => {
  return (
    <div>
        <Header />
        <WorkerSignUp />
    </div>
  )
}

export default WorkerSignUpPage